import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map} from "rxjs/operators";
import {RENAME_ACTION, RenameActions} from "../actions/rename-actions";
// @ts-ignore
import {AppStore} from '@alfresco/aca-shared/store';
import {Store} from '@ngrx/store';
import {MatDialog} from "@angular/material/dialog";
import {RenameDialogComponent} from "../src/lib/dialogs/rename-dialog/rename-dialog.component";

@Injectable()
export class RenameEffects {

  protected store = inject<Store<AppStore>>(Store<AppStore>);

  constructor(private actions$: Actions,
              public dialog: MatDialog
  ) {
  }
  rename$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<RenameActions>(RENAME_ACTION),
        map((action) => {
          if (action.payload) {
            this.openDialog(action.payload);
          }
        })
      ),
    {dispatch: false}
  );

  openDialog(node: any): void {
    this.dialog.open(RenameDialogComponent, {
      data: node,
    });
  }
}
